<!-- FAD MASIVO DESKTOP -->
<div class="fad-desktop" *ngIf="isMobile === false  && isTablet === false">
    <div class="billing-info-container">
        <div class="title" style="margin-bottom: 20px">
            <p>Dados de faturação</p>
        </div>
        <div class="form" [formGroup]="form" *ngIf="!billingAdded">
            <mat-form-field class="w-25" appearance="outline">
                <mat-label>País</mat-label>
                <mat-select placeholder="Selecciona" required formControlName="country">
                    <mat-option>--</mat-option>
                    <mat-option *ngFor="let countrie of countries"
                                value='{{countrie.name_es}}'>{{countrie.name_es}}</mat-option>
                </mat-select>
                <mat-error>Campo obrigatório </mat-error>
            </mat-form-field>
            <mat-form-field class="w-30" appearance="outline">
                <mat-label>Estado</mat-label>
                <input maxlength="50" appOnlyLetters formControlName="state" required matInput autocomplete="off" type="text">
                <mat-error>Insira no mínimo 2 caracteres e no máximo 50.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-40" appearance="outline">
                <mat-label>Cidade</mat-label>
                <input maxlength="50"  appOnlyLetters formControlName="city" required matInput autocomplete="off" type="text">
                <mat-error>Insira no mínimo 2 caracteres e no máximo 50.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-25" appearance="outline">
                <mat-label>CEP</mat-label>
                <input appToUppercase maxlength="8" required formControlName="code" matInput autocomplete="off"
                       type="text">
                <mat-error>Campo obrigatório </mat-error>
            </mat-form-field>
            <mat-form-field class="w-70" appearance="outline">
                <mat-label>Endereço</mat-label>
                <input maxlength="50" appToUppercase required formControlName="address" matInput autocomplete="off" type="text">
                <mat-error>Insira no mínimo 2 caracteres e no máximo 50.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-55" appearance="outline">
                <mat-label>CPF/CNPJ</mat-label>
                <input required appToUppercase formControlName="rfc" maxlength="22" matInput autocomplete="off"
                       type="text">
                <mat-error>Insira seu CPF/CNPJ.</mat-error>
            </mat-form-field>
            <mat-form-field class="w-40" appearance="outline">
                <mat-label>Nome/Razão social</mat-label>
                <input maxlength="50" required appToUppercase formControlName="businessName" matInput autocomplete="off" type="text">
                <mat-error>Insira no mínimo 2 caracteres e no máximo 50.</mat-error>
            </mat-form-field>
            <div class="actions">
                <div class="check">
                    <mat-checkbox [(ngModel)]="acepptTerms" [ngModelOptions]="{standalone: true}"> Aceito o </mat-checkbox>
                    <a class="link" [routerLink]="['/aviso-de-privacidade']" target="_blank">aviso de privacidade</a> e os
                    <a class="link" [routerLink]="['/termos-e-condicoes']" target="_blank">termos e condições.</a>
                </div>
            </div>
        </div>

        <div class="form">
            <div class="edit-btn">
                <button id="agregar_datos_facturacion" style="margin-left: calc( 100% - 340px );" *ngIf="!billingAdded" [disabled]="form.invalid || !acepptTerms" mat-raised-button
                        (click)="saveData()" class="black-button">
                    CONTINUAR
                </button>
            </div>
        </div>

        <div class="billing-added flex" *ngIf="billingAdded">
            <div class="item">
                <div class="info">
                    <p class="title">País</p>
                    <p>{{billingData?.country}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item">
                <div class="info">
                    <p class="title">CEP</p>
                    <p>{{billingData?.code}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item">
                <div class="info">
                    <p class="title">Estado</p>
                    <p>{{billingData?.state}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item">
                <div class="info">
                    <p class="title">CPF/CNPJ</p>
                    <p>{{billingData?.rfc}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item">
                <div class="info">
                    <p class="title">Cidade</p>
                    <p>{{billingData?.city}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>

            <div class="item">
                <div class="info">
                    <p class="title">Endereço</p>
                    <p>{{billingData?.address}}</p>
                </div>
                <div class="icon">
                    <mat-icon>done</mat-icon>
                </div>
            </div>
        </div>
        <div class="form">
            <div class="edit-btn">
                <button mat-raised-button *ngIf="billingAdded" (click)="refreshEmpty()" class="white-button">
                    EDITAR
                </button>
            </div>
        </div>
        <div class="disabled" *ngIf="!this.sessionService.getDataPay()"></div>
    </div>
</div>

<!-- FAD MASIVO RESPONSIVO -->
<div class="fad-movil" *ngIf="isMobile === true  || isTablet === true">

    <div class="content-res">
        Dados de faturação
    </div>

    <div class="form" [formGroup]="form" *ngIf="!billingAdded">
        <mat-form-field class="w-25" appearance="outline">
            <mat-label>País</mat-label>
            <mat-select required placeholder="Selecciona" formControlName="country">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let countrie of countries"
                            value='{{countrie.name_es}}'>{{countrie.name_es}}</mat-option>
            </mat-select>
            <mat-error>Campo obrigatório</mat-error>
        </mat-form-field>
        <mat-form-field class="w-30" appearance="outline">
            <mat-label>Estado</mat-label>
            <input maxlength="50" required appOnlyLetters formControlName="state" matInput autocomplete="off" type="text">
            <mat-error>Insira no mínimo 2 caracteres e no máximo 50.</mat-error>
        </mat-form-field>
        <mat-form-field class="w-40" appearance="outline">
            <mat-label>Cidade</mat-label>
            <input maxlength="50" required appOnlyLetters formControlName="city" matInput autocomplete="off" type="text">
            <mat-error>Insira no mínimo 2 caracteres e no máximo 50.</mat-error>
        </mat-form-field>
        <mat-form-field class="w-25" appearance="outline">
            <mat-label>CEP</mat-label>
            <input appToUppercase maxlength="8" required formControlName="code" matInput autocomplete="off"
                   type="text">
            <mat-error>Campo obrigatório</mat-error>
        </mat-form-field>
        <mat-form-field class="w-70" appearance="outline">
            <mat-label>Endereço</mat-label>
            <input required maxlength="50" appToUppercase formControlName="address" matInput autocomplete="off" type="text">
            <mat-error>Insira no mínimo 2 caracteres e no máximo 50.</mat-error>
        </mat-form-field>
        <mat-form-field class="w-55" appearance="outline">
            <mat-label>CPF/CNPJ</mat-label>
            <input required appToUppercase formControlName="rfc" maxlength="22" matInput autocomplete="off" type="text">
            <mat-error>Insira seu CPF/CNPJ.</mat-error>
        </mat-form-field>
        <mat-form-field class="w-40" appearance="outline">
            <mat-label>Nome/Razão social</mat-label>
            <input required maxlength="50" appToUppercase formControlName="businessName" matInput autocomplete="off" type="text">
            <mat-error>Insira no mínimo 2 caracteres e no máximo 50.</mat-error>
        </mat-form-field>
        <div class="actions">
            <div class="check">
                <mat-checkbox [(ngModel)]="acepptTerms" [ngModelOptions]="{standalone: true}"> Aceito o </mat-checkbox>
                <a class="link" [routerLink]="['/aviso-de-privacidade']" target="_blank">aviso de privacidade</a> e os
                <a class="link" [routerLink]="['/termos-e-condicoes']" target="_blank">termos e condições.</a>
            </div>
            <button id="agregar_datos_facturacion_movil" [disabled]="form.invalid || !acepptTerms" mat-raised-button (click)="saveData()"
                    class="black-button">
                Continuar
            </button>
        </div>
    </div>

    <div class="billing-added" *ngIf="billingAdded">
        <div class="item">
            <div class="info">
                <p class="title">País</p>
                <p>{{billingData?.country}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item">
            <div class="info">
                <p class="title">CEP</p>
                <p>{{billingData?.code}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item">
            <div class="info">
                <p class="title">Estado</p>
                <p>{{billingData?.state}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item">
            <div class="info">
                <p class="title">CPF/CNPJ</p>
                <p>{{billingData?.rfc}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item">
            <div class="info">
                <p class="title">Cidade</p>
                <p>{{billingData?.city}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>

        <div class="item">
            <div class="info">
                <p class="title">Endereço</p>
                <p>{{billingData?.address}}</p>
            </div>
            <div class="icon">
                <mat-icon>done</mat-icon>
            </div>
        </div>
    </div>
    <div class="form">
        <div class="edit-btn">
            <button mat-raised-button *ngIf="billingAdded" (click)="refreshEmpty()" class="blanco-button">
                EDITAR
            </button>
        </div>
    </div>
    <div class="disabled" *ngIf="!active"></div>

</div>
